import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Menu as MenuIcon, X } from "lucide-react";
import { useCart } from "../context/CartContext";

const links = [
  { to: "/menu", label: "Shop" },
  { to: "/medical-card", label: "Medical Card" },
  { to: "/locations/salt-lake-city", label: "Locations" },
  { to: "/#manifesto", label: "Your Journey" },
];

export const Header = () => {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setMobile(false), [loc.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-ink/70 backdrop-blur-xl border-b border-bone/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <Link to="/" data-testid="logo-link" className="font-display font-extrabold text-2xl tracking-tighter uppercase">
          Bee<span className="text-honey">hive</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-xs tracking-[0.2em] uppercase font-medium text-bone/80 hover:text-honey transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="cart-button"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 text-bone hover:text-honey transition-colors"
          >
            <ShoppingBag size={22} />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-honey text-ink text-[10px] font-bold rounded-full h-5 w-5 flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button data-testid="mobile-menu-toggle" className="md:hidden text-bone" onClick={() => setMobile((m) => !m)}>
            {mobile ? <X size={24} /> : <MenuIcon size={24} />}
          </button>
        </div>
      </div>

      {mobile && (
        <div className="md:hidden bg-ink/95 backdrop-blur-xl border-t border-bone/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="text-sm tracking-[0.2em] uppercase text-bone/90 hover:text-honey">
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
